import styled from '@emotion/styled';
import { Variables } from '../variables';

export const Container = styled.div`
    border: 1px solid ${Variables.Colors.n15};
    border-radius: ${Variables.Rounded.large};
    box-shadow: ${Variables.Shadows.small};
    padding: 21px;
    margin: 12px 24px;
    display: flex;
    flex-direction: column;
`;

export const Header = styled.div`
    display: flex;
    align-items: center;
    cursor: pointer;
    user-select: none;
`;

export const Title = styled.div`
    flex: 1;
    font-size: 14px;
    font-weight: 600;
    color: ${Variables.Colors.n85};
    text-transform: uppercase;
    letter-spacing: 0.5px;
`;

export const ChevronIcon = styled.div<{ isOpen: boolean }>`
    display: flex;
    align-items: center;
    justify-content: center;
    transition: transform 0.2s ease;
    transform: ${props => props.isOpen ? 'rotate(90deg)' : 'rotate(0deg)'};
    color: ${Variables.Colors.n70};
`;

export const Content = styled.div<{ isOpen: boolean }>`
    max-height: ${props => props.isOpen ? '2000px' : '0'};
    overflow: ${props => props.isOpen ? 'visible' : 'hidden'};
    transition: max-height 0.3s ease;
    margin-top: ${props => props.isOpen ? '16px' : '0'};
`;

